module.exports = __webpack_public_path__ + "img/avg_score.b9bec96b.svg";